import {
  AlertTriangle,
  ChevronDown,
  CreditCard,
  FileCheck2,
  RotateCcw,
  ShieldCheck,
} from "lucide-react";

const TERMS_VERSION = "2026-07-16";

const content = {
  hu: {
    kicker: "Bérleti és fizetési feltételek",
    title: "Minden fontos feltétel egy helyen",
    intro:
      "A foglalás elküldése előtt kérjük, olvasd el az alábbi feltételeket. A foglalási folyamat végén külön jelölőnégyzettel kell igazolnod, hogy elolvastad és elfogadod őket.",
    version: `Hatályos változat: ${TERMS_VERSION}`,
    paymentTitle: "Egyösszegű fizetés",
    paymentBody:
      "A foglalás a készülék elérhetőségének visszaigazolása és a megküldött fizetési linken szereplő teljes összeg sikeres megfizetése után válik véglegessé. A fizetendő összeg a bérleti díjból, a kiválasztott extrákból és a külön feltüntetett visszatérítendő kaucióból állhat.",
    depositTitle: "Visszatérítendő kaució",
    depositBody:
      "A kaució nem a szolgáltatás díja, hanem a Telefonka és tartozékai sértetlen, hiánytalan és határidőben történő visszaadásának biztosítéka. A pontos összeget a fizetési összesítő és a visszaigazoló e-mail külön soron mutatja.",
    refundTitle: "Kaució visszatérítése",
    refundBody:
      "A Telefonka visszaérkezése után ellenőrizzük a készüléket és a tartozékokat. Sértetlen, rendeltetésszerű használat és hiánytalan visszaadás esetén a kaució teljes összegének visszatérítését az ellenőrzést követő 5 munkanapon belül elindítjuk az eredeti fizetési módra. A banki jóváírás ideje ettől eltérhet.",
    fullTitle: "Részletes szerződési feltételek",
    fullHint: "Nyisd le és olvasd el a teljes szöveget a foglalás véglegesítése előtt.",
    sections: [
      {
        title: "1. A szerződés tárgya és létrejötte",
        paragraphs: [
          "A szolgáltatás tárgya a foglalásban kiválasztott Telefonka és tartozékainak határozott időre történő bérbeadása, valamint a kiválasztott kiegészítő szolgáltatások biztosítása.",
          "A foglalási űrlap elküldése foglalási igénynek minősül. A szerződés akkor jön létre, amikor a Szolgáltató a készülék elérhetőségét írásban visszaigazolja, és a fizetési kötelezettséggel járó teljes összeg sikeresen beérkezik.",
          "A foglalás részét képezi a kiválasztott dátum, készülék, extrák, a fizetési összesítő, a visszaigazolás és a jelen feltételek elfogadott változata.",
        ],
      },
      {
        title: "2. Díjak és fizetés",
        paragraphs: [
          "A fizetendő teljes összeget a fizetést megelőző összesítő egyértelműen, forintban mutatja. A bérleti díj, az extrák és a kaució külön soron jelenik meg.",
          "A foglalás egy összegben fizetendő. A fizetési gomb használata fizetési kötelezettséggel járó megrendelést jelent.",
          "Sikertelen vagy megszakított fizetés esetén a foglalás nem válik véglegessé. A Szolgáltató jogosult a fizetésre fenntartott időpontot a fizetési határidő lejárta után felszabadítani.",
        ],
      },
      {
        title: "3. Kaució, ellenőrzés és visszatérítés",
        paragraphs: [
          "A kaució a bérelt készülék, a kagyló, a kábelek, a töltő, a csomagolás és minden átadott tartozék biztosítéka.",
          "A kaució teljes egészében visszajár, ha a Telefonka és valamennyi tartozéka hiánytalanul, rendeltetésszerű használatra alkalmas, az átvételkori állapotnak megfelelő állapotban és a megadott határidőben érkezik vissza.",
          "A normál használatból eredő, csekély és az eszköz működését nem befolyásoló elhasználódás önmagában nem alapoz meg levonást.",
        ],
      },
      {
        title: "4. Sérülés, hiány vagy késedelmes visszaadás",
        paragraphs: [
          "Sérülés, hiány, nem rendeltetésszerű használat vagy késedelmes visszaadás esetén kizárólag az igazolt és indokolt javítási, pótlási, rendkívüli tisztítási vagy késedelemből eredő közvetlen költség vonható le a kaucióból.",
          "A Szolgáltató a levonás okáról, összegéről és alapjául szolgáló körülményekről írásos elszámolást küld. A fennmaradó kauciórészt az elszámolással egyidejűleg visszatéríti.",
          "Ha a bizonyítható kár meghaladja a kaució összegét, a Szolgáltató a kaución felüli, igazolt kár megtérítését is kérheti a vonatkozó jogszabályok szerint.",
        ],
      },
      {
        title: "5. Átadás, használat és visszaküldés",
        paragraphs: [
          "A bérlő köteles a Telefonkát a használati útmutató szerint, száraz, biztonságos és felügyelhető helyen használni, valamint megóvni nedvességtől, szélsőséges hőmérséklettől, ütődéstől és illetéktelen szétszereléstől.",
          "A készülék harmadik személynek nem adható tovább, nem alakítható át, és kizárólag a foglalásban megjelölt eseményhez használható.",
          "A bérlő köteles a készüléket és tartozékait a kapott csomagolásban, a visszaküldési tájékoztató szerint és a megadott határidőig átadni a futárnak.",
        ],
      },
      {
        title: "6. Lemondás és időpont-módosítás",
        paragraphs: [
          "Az esemény előtt legalább 30 nappal közölt lemondás esetén a szolgáltatási díj 80%-a visszatérítésre kerül; 20% foglalási és adminisztrációs díjként kerül levonásra.",
          "Az esemény előtt 8–29 nappal közölt lemondás esetén a szolgáltatási díj 60%-a visszatérítésre kerül; 40% a fenntartott időpont és az elvégzett előkészítés fedezete.",
          "Az eseményt megelőző 7 napon belül közölt lemondás esetén a szolgáltatási díj nem téríthető vissza. A még vissza nem adott vagy át nem adott eszközhöz kapcsolódó kaucióra ez nem vonatkozik.",
          "Legalább 14 nappal az eredeti esemény előtt egy alkalommal díjmentes időpont-módosítás kérhető, az új időpont szabad kapacitásának függvényében.",
          "A lemondást és az időpont-módosítást írásban kell jelezni. A kötelező fogyasztóvédelmi jogok, ideértve az esetlegesen alkalmazandó elállási vagy felmondási jogot, elsőbbséget élveznek a jelen önkéntes lemondási szabályokkal szemben.",
        ],
      },
      {
        title: "7. Hibabejelentés és felelősség",
        paragraphs: [
          "A bérlő köteles a működési hibát vagy sérülést haladéktalanul jelezni, és követni a Szolgáltató észszerű hibaelhárítási utasításait.",
          "A Szolgáltató nem felel az olyan felvétel elmaradásáért vagy minőségi problémájáért, amely a használati útmutató be nem tartásából, áramellátási problémából, rongálásból, külső körülményből vagy jogosulatlan beavatkozásból ered.",
          "A Szolgáltató a saját érdekkörében felmerült, bizonyított hibáért a vonatkozó kötelező jogszabályok szerint felel.",
        ],
      },
      {
        title: "8. Kapcsolattartás, panasz és jogérvényesítés",
        paragraphs: [
          "A foglalással, fizetéssel, lemondással, kárral és kaució-visszatérítéssel kapcsolatos nyilatkozatokat írásban kell megtenni a visszaigazolásban megadott elérhetőségen.",
          "A panaszokat a Szolgáltató kivizsgálja és írásban megválaszolja. A fogyasztó jogosult a lakóhelye vagy tartózkodási helye szerint illetékes békéltető testülethez fordulni, valamint igényét bírósági úton érvényesíteni.",
          "A Szolgáltató pontos vállalkozási, kapcsolattartási és panaszkezelési adatait a végleges fizetési rendszer aktiválása előtt az Impresszumban és a visszaigazolásban is fel kell tüntetni.",
        ],
      },
      {
        title: "9. Elfogadás és bizonyíthatóság",
        paragraphs: [
          "A jelölőnégyzet nincs előre bejelölve. A foglalás csak akkor küldhető el, ha a bérlő kifejezetten kijelenti, hogy a jelen feltételeket és az adatkezelési tájékoztatót elolvasta és elfogadja.",
          "A rendszer rögzítheti az elfogadás időpontját és a feltételek verzióját. A visszaigazoló e-mailben a szerződés lényeges adatait és az elfogadott feltételeket tartósan hozzáférhető formában is meg kell küldeni.",
        ],
      },
    ],
    legalNotice:
      "A jelen szöveg a Telefonka szolgáltatására szabott működési tervezet. Online fizetés indítása előtt a vállalkozás pontos adataival, az adatkezelési tájékoztatóval és szakjogászi ellenőrzéssel szükséges véglegesíteni.",
    acceptHint:
      "A foglalás utolsó lépésében található jelölőnégyzet elfogadása kötelező; előre nincs bejelölve.",
    cta: "Tovább a foglaláshoz",
  },
  en: {
    kicker: "Rental and payment terms",
    title: "Every important condition in one place",
    intro:
      "Please read the terms below before submitting your booking. At the final booking step, you must actively tick a separate checkbox confirming that you have read and accepted them.",
    version: `Effective version: ${TERMS_VERSION}`,
    paymentTitle: "Single payment",
    paymentBody:
      "The booking becomes final after device availability has been confirmed and the full amount shown on the payment link has been paid successfully. The amount may include the rental fee, selected extras and a separately displayed refundable security deposit.",
    depositTitle: "Refundable security deposit",
    depositBody:
      "The security deposit is not a service fee. It secures the timely, complete and undamaged return of the Telefonka and its accessories. The exact amount is displayed separately in the payment summary and confirmation email.",
    refundTitle: "Returning the deposit",
    refundBody:
      "After the Telefonka is returned, we inspect the device and its accessories. If everything is complete, undamaged and used as intended, we initiate the full deposit refund to the original payment method within five business days of inspection. Bank processing time may vary.",
    fullTitle: "Detailed contractual terms",
    fullHint: "Open and read the full text before completing the booking.",
    sections: [
      {
        title: "1. Subject and formation of the contract",
        paragraphs: [
          "The service covers the fixed-term rental of the Telefonka and its accessories selected in the booking, together with any selected additional services.",
          "Submitting the booking form constitutes a booking request. The contract is formed when the Provider confirms availability in writing and the full payment obligation is successfully settled.",
          "The selected date, device, extras, payment summary, confirmation and accepted version of these terms form part of the booking.",
        ],
      },
      {
        title: "2. Fees and payment",
        paragraphs: [
          "The complete amount due is clearly displayed in Hungarian forints before payment. The rental fee, extras and security deposit are shown as separate items.",
          "The booking is paid in one transaction. Activating the payment button means placing an order with an obligation to pay.",
          "A failed or interrupted payment does not finalise the booking. The Provider may release the reserved date after the payment deadline expires.",
        ],
      },
      {
        title: "3. Deposit, inspection and refund",
        paragraphs: [
          "The deposit secures the rented device, handset, cables, charger, packaging and every supplied accessory.",
          "The deposit is refunded in full if the Telefonka and all accessories are returned complete, fit for intended use, in their original condition and by the stated deadline.",
          "Minor wear resulting from normal use that does not affect operation does not in itself justify a deduction.",
        ],
      },
      {
        title: "4. Damage, missing items or late return",
        paragraphs: [
          "In the event of damage, missing items, misuse or late return, only documented and reasonable repair, replacement, exceptional cleaning or direct delay-related costs may be deducted from the deposit.",
          "The Provider sends a written statement explaining the reason, amount and basis of any deduction. The remaining part of the deposit is refunded at the same time.",
          "If the documented loss exceeds the deposit, the Provider may claim the excess documented loss under applicable law.",
        ],
      },
      {
        title: "5. Delivery, use and return",
        paragraphs: [
          "The renter must use the Telefonka according to the instructions, in a dry, safe and supervised location, and protect it from moisture, extreme temperatures, impacts and unauthorised dismantling.",
          "The device may not be transferred to a third party, altered or used outside the event stated in the booking.",
          "The device and accessories must be returned in the supplied packaging, according to the return instructions and by the stated deadline.",
        ],
      },
      {
        title: "6. Cancellation and date changes",
        paragraphs: [
          "For cancellation at least 30 days before the event, 80% of the service fee is refunded and 20% is retained as a reservation and administration fee.",
          "For cancellation 8–29 days before the event, 60% of the service fee is refunded and 40% covers the reserved date and preparation already completed.",
          "For cancellation within seven days of the event, the service fee is non-refundable. This does not affect a security deposit relating to equipment not yet delivered or retained.",
          "One free date change may be requested at least 14 days before the original event, subject to availability on the new date.",
          "Cancellation and date-change requests must be submitted in writing. Mandatory consumer rights, including any applicable statutory withdrawal or termination right, take precedence over these voluntary cancellation rules.",
        ],
      },
      {
        title: "7. Fault reporting and liability",
        paragraphs: [
          "The renter must report faults or damage without delay and follow the Provider's reasonable troubleshooting instructions.",
          "The Provider is not responsible for missing or poor-quality recordings resulting from failure to follow instructions, power problems, damage, external conditions or unauthorised interference.",
          "The Provider remains responsible for proven faults within its own control under mandatory applicable law.",
        ],
      },
      {
        title: "8. Communication, complaints and remedies",
        paragraphs: [
          "Statements concerning the booking, payment, cancellation, damage and deposit refund must be submitted in writing using the contact details in the confirmation.",
          "Complaints are investigated and answered in writing. Consumers may contact the competent Hungarian conciliation body or enforce their claims before a court.",
          "The Provider's complete business, contact and complaint-handling details must be added to the legal notice and confirmation before live online payments are activated.",
        ],
      },
      {
        title: "9. Acceptance and records",
        paragraphs: [
          "The checkbox is not preselected. The booking may only be submitted after the renter expressly confirms that they have read and accepted these terms and the privacy notice.",
          "The system may record the acceptance timestamp and terms version. The confirmation email must also provide the essential contract details and accepted terms in a durable format.",
        ],
      },
    ],
    legalNotice:
      "This text is an operational draft tailored to the Telefonka service. Before online payments go live, it must be completed with the Provider's exact business details, the privacy notice and a review by a Hungarian legal professional.",
    acceptHint:
      "Acceptance through the checkbox in the final booking step is mandatory and the box is never preselected.",
    cta: "Continue to booking",
  },
};

function HighlightCard({ icon: Icon, title, body }) {
  return (
    <article className="tk-card p-6 md:p-7">
      <span className="w-11 h-11 rounded-full bg-[rgba(110,30,43,0.08)] text-[var(--burgundy)] flex items-center justify-center">
        <Icon size={19} aria-hidden="true" />
      </span>
      <h3 className="font-serif text-2xl mt-5 text-[var(--ink)]">{title}</h3>
      <p className="mt-3 text-sm leading-relaxed text-[var(--ink-soft)]">{body}</p>
    </article>
  );
}

export default function RentalTerms({ lang = "hu" }) {
  const c = content[lang] || content.hu;

  return (
    <section
      id="payment-terms"
      data-testid="section-payment-terms"
      className="py-20 md:py-28 bg-[var(--beige-50)] tk-section-anchor"
      aria-labelledby="rental-terms-title"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-10">
        <div className="max-w-3xl mx-auto text-center">
          <span className="tk-eyebrow">
            <span className="tk-divider" aria-hidden="true" />
            {c.kicker}
            <span className="tk-divider" aria-hidden="true" />
          </span>
          <h2
            id="rental-terms-title"
            className="font-serif text-4xl sm:text-5xl mt-5 text-[var(--ink)]"
          >
            {c.title}
          </h2>
          <p className="mt-5 text-[var(--ink-soft)] text-lg leading-relaxed">
            {c.intro}
          </p>
          <p className="mt-3 text-xs uppercase tracking-widest text-[var(--burgundy)]">
            {c.version}
          </p>
        </div>

        <div className="mt-10 grid md:grid-cols-3 gap-5">
          <HighlightCard icon={CreditCard} title={c.paymentTitle} body={c.paymentBody} />
          <HighlightCard icon={ShieldCheck} title={c.depositTitle} body={c.depositBody} />
          <HighlightCard icon={RotateCcw} title={c.refundTitle} body={c.refundBody} />
        </div>

        <details className="group tk-card mt-7 overflow-hidden">
          <summary className="list-none cursor-pointer p-6 sm:p-8 flex items-start justify-between gap-5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px] focus-visible:outline-[var(--burgundy)]">
            <span className="flex items-start gap-4">
              <span className="w-11 h-11 rounded-full bg-[rgba(110,30,43,0.08)] text-[var(--burgundy)] flex items-center justify-center shrink-0">
                <FileCheck2 size={19} aria-hidden="true" />
              </span>
              <span>
                <span className="block font-serif text-2xl text-[var(--ink)]">{c.fullTitle}</span>
                <span className="block mt-1 text-sm text-[var(--ink-soft)]">{c.fullHint}</span>
              </span>
            </span>
            <ChevronDown
              size={22}
              aria-hidden="true"
              className="mt-2 shrink-0 text-[var(--burgundy)] transition-transform group-open:rotate-180"
            />
          </summary>

          <div className="border-t border-[rgba(44,31,26,0.10)] px-6 pb-7 sm:px-8 sm:pb-9">
            <div className="divide-y divide-[rgba(44,31,26,0.10)]">
              {c.sections.map((section) => (
                <article key={section.title} className="py-6">
                  <h3 className="font-serif text-xl text-[var(--ink)]">{section.title}</h3>
                  <div className="mt-3 space-y-3 text-sm leading-relaxed text-[var(--ink-soft)]">
                    {section.paragraphs.map((paragraph) => (
                      <p key={paragraph}>{paragraph}</p>
                    ))}
                  </div>
                </article>
              ))}
            </div>

            <div className="mt-2 rounded-2xl border border-[rgba(110,30,43,0.18)] bg-[rgba(110,30,43,0.045)] p-5 flex items-start gap-3">
              <AlertTriangle
                size={19}
                className="mt-0.5 shrink-0 text-[var(--burgundy)]"
                aria-hidden="true"
              />
              <p className="text-sm leading-relaxed text-[var(--ink-soft)]">{c.legalNotice}</p>
            </div>
          </div>
        </details>

        <div className="mt-7 rounded-2xl bg-[var(--burgundy)] text-white p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-5">
          <p className="text-sm leading-relaxed max-w-3xl">{c.acceptHint}</p>
          <a
            href="#booking"
            className="inline-flex min-h-11 items-center justify-center rounded-full bg-white px-5 text-sm font-medium text-[var(--burgundy)] hover:bg-[var(--beige-100)] transition shrink-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
          >
            {c.cta}
          </a>
        </div>
      </div>
    </section>
  );
}
